import { notificationService as apiNotificationService } from './apiService';

class NotificationService {
    constructor() {
        this.subscribers = new Map();
    }

    // Register FCM token with the server
    async registerFCMToken(driverId, token) {
        return await apiNotificationService.registerFCMToken(driverId, token);
    }

    // Subscribe to notification events
    subscribe(event, callback) {
        if (!this.subscribers.has(event)) {
            this.subscribers.set(event, []);
        }
        this.subscribers.get(event).push(callback);

        // Return unsubscribe function
        return () => {
            const callbacks = this.subscribers.get(event);
            if (callbacks) {
                const index = callbacks.indexOf(callback);
                if (index > -1) {
                    callbacks.splice(index, 1);
                }
            }
        };
    }

    // Emit notification event
    emit(event, data) {
        const callbacks = this.subscribers.get(event);
        if (callbacks) {
            callbacks.forEach(callback => {
                try {
                    callback(data);
                } catch (err) {
                    console.error('Notification callback error:', err);
                }
            });
        }
    }

    // Handle shipment status change notifications
    handleShipmentNotification(payload) {
        const data = payload.data || {};
        const notification = payload.notification || {};

        switch (data.type) {
            case 'shipment_assigned':
                this.emit('shipment_assigned', {
                    shipmentId: data.shipmentId,
                    message: notification.body,
                    timestamp: new Date()
                });
                break;

            case 'shipment_status_changed':
                this.emit('shipment_status_changed', {
                    shipmentId: data.shipmentId,
                    newStatus: data.newStatus,
                    message: notification.body,
                    timestamp: new Date()
                });
                break;

            case 'urgent_message':
                this.emit('urgent_message', {
                    message: notification.body,
                    priority: data.priority || 'high',
                    timestamp: new Date()
                });
                break;

            default:
                this.emit('general_notification', {
                    title: notification.title,
                    message: notification.body,
                    data: data,
                    timestamp: new Date()
                });
        }
    }

    // Show in-app notification
    showInAppNotification(title, message, type = 'info', duration = 5000) {
        this.emit('in_app_notification', {
            title,
            message,
            type,
            duration,
            id: Date.now()
        });
    }
}


export const sendNotificationToDriver = async (driverId, type, data) => {
    try {
        let payload;
        
        switch (type) {
            case 'shipment_assigned':
                // Dùng auto notification cho các thông báo quan trọng
                payload = {
                    notification: {
                        title: 'Chuyến xe mới',
                        body: `Bạn có chuyến xe mới #${data.shipmentId}`,
                        icon: '/icon.png'
                    },
                    data: {
                        type: 'shipment_assigned',
                        shipmentId: data.shipmentId.toString(),
                        url: `/shipment/${data.shipmentId}`
                    }
                };
                break;
                
            case 'status_update':
                // Dùng data-only cho thông báo ít quan trọng
                payload = {
                    data: {
                        title: 'Cập nhật trạng thái',
                        body: `Chuyến xe #${data.shipmentId} đã được cập nhật`,
                        icon: '/icon.png',
                        type: 'status_update',
                        shipmentId: data.shipmentId.toString(),
                        status: data.status.toString()
                    }
                };
                break;
                
            case 'urgent':
                // Dùng auto notification cho khẩn cấp
                payload = {
                    notification: {
                        title: 'Thông báo khẩn',
                        body: data.message,
                        icon: '/icon.png'
                    },
                    data: {
                        type: 'urgent',
                        priority: 'high'
                    }
                };
                break;
        }
        
        // Gửi qua API endpoint
        const response = await fetch('/api/send-notification', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                driverId: driverId,
                payload: payload
            })
        });
        
        return response.json();
    } catch (error) {
        console.error('Error sending notification:', error);
        throw error;
    }
};

export const notificationService = new NotificationService();
